import PropTypes from 'prop-types'
import styled from 'styled-components'

import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'

const Image = styled.img`
  width: 80px;
`

const SidebarBase64Image = ({ base64Content, contentType }) => {
  if (!base64Content || !contentType) {
    return <SidebarText text='' />
  }

  const img = `data:${contentType};charset=utf-8;base64,${base64Content}`

  return (
    <Image src={img} />
  )
}

SidebarBase64Image.propTypes = {
  base64Content: PropTypes.string,
  contentType: PropTypes.string,
}

export default SidebarBase64Image
